import { render, staticRenderFns } from "./XulosaPechat.vue?vue&type=template&id=c4a87512"
import script from "./XulosaPechat.vue?vue&type=script&lang=js"
export * from "./XulosaPechat.vue?vue&type=script&lang=js"
import style0 from "./XulosaPechat.vue?vue&type=style&index=0&id=c4a87512&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports